import React, {useState, useEffect} from 'react';
import { TextField, MenuItem } from '@mui/material';
import { handleValidateCodevalue } from '../Utility/constant';
import { useSelector } from 'react-redux';

const SelectBoxWithLabel = ({disabled, helperText ,ownerdropdown = true , isViewMode = false , name, label, className="", isStatic = true, optionMenuItem, value, handleOnChange, ...otherProps}) => {

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);


    return (
        <TextField
            sx = {{width : "210px"}}
            disabled = {isViewMode ||disabled}
            name = {name}
            value = {value}
            onChange={handleOnChange}
            select
            variant='standard'
            {...otherProps}
            label = {label}
            helperText = {helperText || ""}
            // InputLabelProps={{
            //     shrink: true,
            // }}
        >
            {optionMenuItem?.map((option) => (
                isStatic ? (<MenuItem key={option.label} value={option?.value ? option?.value : option?.label}>
                    {handleValidateCodevalue(internationalise,option.label)}
                </MenuItem>) : (ownerdropdown ?
                    <MenuItem key={option?.id} value={option?.id}>
                    {option?.name}
                    </MenuItem>
                    :
                    <MenuItem key={option?.name} value={option?.name}>
                    {handleValidateCodevalue(internationalise, option?.name)}
                    </MenuItem>
                )
                
            ))}
        </TextField>
                    

    )
}

export default SelectBoxWithLabel; 